<template>
  <div style="padding: 0 30px">
    <el-table :data="records" height="390" style="border: 1px solid darkgrey" v-loading="records.length === 0">
      <el-table-column align="center" label="操作时间" prop="createTime" width="140"></el-table-column>
      <el-table-column align="center" label="操作人" prop="operatorName"></el-table-column>
      <el-table-column align="center" label="工序" prop="curProcedureName">
        <template #default="{row}">
          <div>{{row.curProcedureName}}{{statusText(row.curWorkStatus)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="内容" prop="content"></el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    name: 'OperaRecordPanel',
    props: {
      records: Array
    },
    methods: {
      statusText (status) {
        switch (status) {
          // case 'WAIT_CONFIRM':
          //   return ' - ' + '待确认'

          case 'WAIT':
            return ' - ' + '待施工'
        }
        return ''
      }
    }
  }
</script>
